"use client";
import React, { useState, useEffect, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { NextAero, PreviousAero } from "@/utlility/icons";
import ServiceCard from "./service-card/ServiceCard";

const CategorySlider = ({ dataToMap, generateCategoryPath }) => {
    const dataLength = dataToMap?.length || 0;
    const [showButtons, setShowButtons] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            let activeSlides = 1;
            if (width >= 1400) activeSlides = 4;
            else if (width >= 992) activeSlides = 3;
            else if (width >= 768) activeSlides = 2;
            
            setShowButtons(dataLength > activeSlides);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [dataLength]);

    const [emblaRef, emblaApi] = useEmblaCarousel(
        { loop: showButtons, align: "start" },
        [Autoplay({ delay: 3000, stopOnInteraction: true })]
    );

    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi]);

    useEffect(() => {
        if (emblaApi) {
            emblaApi.reInit({ loop: showButtons, align: "start" });
        }
    }, [emblaApi, showButtons]);

    if (!Array.isArray(dataToMap) || dataToMap.length === 0) return null;

    return (
        <div className="section-content-space categories-slider-content overflow-hidden">
            <div className="embla w-100 overflow-visible category-slider" ref={emblaRef}>
                <div className="embla__container d-flex">
                    {dataToMap.map((item, i) => (
                        <div key={item.id || i} className="embla__slide flex-shrink-0 h-100 category-slide">
                            <ServiceCard
                                image={item.category_image || ""}
                                title={item.category_name}
                                link={generateCategoryPath(item.category_slug)}
                                className="d-flex flex-column h-100"
                                style={{ minHeight: "330px" }}
                            />
                        </div>
                    ))}
                </div>
            </div>

            {showButtons && (
                <div className="d-flex slider-buttons justify-content-center">
                    <button
                        onClick={scrollPrev}
                        className="page-aero prev-nav"
                        aria-label="Previous slide"
                    >
                        <PreviousAero />
                    </button>
                    <button
                        onClick={scrollNext}
                        className="page-aero next-nav"
                        aria-label="Next slide"
                    >
                        <NextAero />
                    </button>
                </div>
            )}

       
        </div>
    );
};

export default CategorySlider;